
class LoupeValidationEngine {

    constructor(item) {

        this.componentHadInteraction = false;
        this.validationRules = item.rules;
        this.item = item;
        this.previousValidationResult = false;
        this.hadValidationAttempted = false;
        this.onError = null;
        this.onSuccess = null;
        this.brokenRules = new Array();

        this.isPreValidated = false;

    }

    setOnErrorHandler(f)
    {
        this.onError = f;
    }
    setOnSuccessHandler(f)
    {
        this.onSuccess = f;
    }

    touched() 
    {
        this.componentHadInteraction = true;
    }
    untouch()
    {
        this.componentHadInteraction = false;
    }

    get isRequired()
    {
        return this.item.required;
    }

    get instantRevalidation() 
    {
        if(this.hadValidationAttempted) 
        {
            return true;
        } else {
            return false;
        }
    }

    getBrokenRules()
    {
        return this.brokenRules;
    }





    // get hadAttempt() 
    // {
    //     return this.hadValidationAttempted;
    // }



    get validationState()
    {
        if( this.hadValidationAttempted )
        {
            return this.previousValidationResult;
        }
        else
        {
            return true;
        }
    }

    revalidate() 
    {
        return this.isValid();
    }
    
    isValid()
    {
        this.hadValidationAttempted = true;

        // validate current item      
        this.previousValidationResult = this.validate();
        
        if( this.previousValidationResult ) {
            if(this.onSuccess ) this.onSuccess();
        } else {
            if(this.onError ) this.onError();
        }

        return this.previousValidationResult;
    }

    validate() 
    {
        this.brokenRules = new Array();

        var value = this.item.getValue();
        var isValid = true;


        // if required, see if no previous interaction with the item occurred; invalidate if none
        if( this.isRequired ) {
            
            if( this.componentHadInteraction == false ) {
                // generally, if item required but not interacted with, invalidate
                this.brokenRules.push( { label : "validation.rules.messages.required", value : "" } );
                isValid = false;
            } else {
                // item was interacted with, but what is essentially needed to fulfill required item?
                if( this.item.type == "chips" || this.item.type == "chip-conditional-likert" || this.item.type == "chip-conditional-slider" || this.item.type == "chip-conditional-chips") {
                    if( this.item.selectedValues.length < 1 ){
                        this.brokenRules.push( { label : "validation.rules.messages.required", value : "" } );
                        isValid = false;
                    } 
                }
            }
        }

        // for conditional chips items, determine if there are other types of errors
        if( this.item.type == "chip-conditional-likert" || this.item.type == "chip-conditional-slider" ) {
            var hadError = false;
            this.item.selectedValues.map(sel => {
                var origIdx = this.item.itemOrder.indexOf(sel);
                if( this.item.scales[origIdx].selectedValue == "" ) {
                    hadError = true;
                }                         
            });
            
            if(hadError) {
                this.brokenRules.push( { label : "validation.rules.messages.conditionals.required", value : "" } );
                isValid = false;
            }
        }

        if( this.item.type == "chip-conditional-chips" ) {
            var hadError = false;
            this.item.selectedValues.map(sel => {
                var origIdx = this.item.itemOrder.indexOf(sel);
                if( this.item.scales[origIdx].selectedExplanations.length == 0 ) {
                    hadError = true;
                }                         
            });

            if(hadError) {
                this.brokenRules.push( { label : "validation.rules.messages.conditionals.requiredChips", value : "" } );
                isValid = false;
            }

        }



        // invalidate, if specific rule was not matched    
        // make sure to match rules to suitable objects    
        this.validationRules.forEach(r => {            
            
            if(r.rule == "minLength" || r.rule == "minElements" ) 
            {
                if( value.length < r.value) 
                {
                    this.brokenRules.push( { label : "validation.rules.messages." + r.rule, value : r.value } ); 
                    isValid = false 
                };
            }
            
            if(r.rule == "maxLength" || r.rule == "maxElements" ) 
            {
                if( value.length > r.value) 
                {
                    this.brokenRules.push( { label : "validation.rules.messages.maxLength", value : r.value } ); 
                    isValid = false 
                };
            }

        });

        return isValid;
    }
}
export default LoupeValidationEngine;